import { queryKeys } from './useQueryFavourite'
import { useFetchFavourite } from './useFetchFavourite'

type GetAllType = ReturnType<ReturnType<typeof useFetchFavourite>['getAll']>

const add = () => {
  const { add } = useFetchFavourite()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: add,
    onMutate: ({ workspaceId }) =>
      queryClient.cancelQueries({ ...queryKeys.all({ workspaceId }) }),
    onSuccess: (responseData, { workspaceId }) => {
      if (!responseData.data || !responseData.included)
        return

      // add to "all"
      queryClient.setQueryData<Awaited<GetAllType>>(
        queryKeys.all({ workspaceId }).queryKey,
        oldData => ({
          ...oldData,
          data: oldData?.data ? [...oldData.data, responseData.data] : [responseData.data],
          included: oldData?.included ? [...oldData.included, ...(responseData.included ?? [])] : responseData.included,
        }),
      )
    },
    onError: (_, { workspaceId }) =>
      queryClient.invalidateQueries({ ...queryKeys.all({ workspaceId }) }),
  })
}

const remove = () => {
  const { remove } = useFetchFavourite()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: remove,
    onMutate: ({ workspaceId }) => queryClient.cancelQueries({ ...queryKeys.all({ workspaceId }) }),
    onSuccess: (_, { id: favouriteId, workspaceId }) => {
      // remove from "all"
      queryClient.setQueryData<Awaited<GetAllType>>(
        queryKeys.all({ workspaceId }).queryKey,
        (oldData) => {
          if (!oldData || !oldData.included)
            return undefined

          const favouriteTemplateId = oldData.data.find(({ id }) => id === favouriteId)
            ?.relationships
            ?.template
            ?.data
            .id

          return {
            ...oldData,
            data: oldData.data.filter(favourite => favourite.id !== favouriteId),
            included: oldData.included.filter(template => template.id !== favouriteTemplateId),
          }
        },
      )
    },
    onError: (_, { workspaceId }) =>
      queryClient.invalidateQueries({ ...queryKeys.all({ workspaceId }) }),
  })
}

export const useMutationFavourite = {
  add,
  remove,
}
